import React, { useEffect } from "react";
import Home from "./Pages/Home";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {
    BrowserRouter,
    Route,
    Routes
} from "react-router-dom";
import Stores from "./Pages/Stores";
import Drawer from "./Components/Layout/Drawer";
import Cart from "./Components/Layout/Cart/Cart";
import { useCartContext } from "./Contexts/CartContext";
import { useOrderTypeContext } from "./Contexts/OrderTypeContext";
import { useLoginContext } from "./Contexts/LoginContext";
import Modal from "./Components/Layout/Modal";
import ServicesChoice from "./Components/Layout/ServicesChoice";
import Checkout from "./Pages/Checkout";
import CartConference from "./Components/Layout/Cart/CartConference";
import { useLayoutContext } from "./Contexts/LayoutContext";
import { TbHash } from "react-icons/tb";
import { useStoreContext } from "./Contexts/StoreContext";
import Badge from "./Components/Layout/Badge";
import LoadingMain from "./Components/Layout/LoadingMain";
import { formatCartId } from "./Utils/Formatters";
import CompanyService from "./Services/CompanyService";
import Offline from "./Components/Layout/Offine";
import ProofPayment from "./Components/Layout/Cart/ProofPayment";
import { useCartHook } from "./Hooks/CartHook";
import { MdTableRestaurant } from "react-icons/md";
import { convertDateToTimestamp, isPastHours } from "./Utils/Helpers";
import TableChoice from "./Components/Layout/Product/TableChoice";
import LoginStoreCounter from "./Components/Layout/LoginStoreCounter";
import LoginBasic from "./Components/Layout/LoginBasic";
import OrderPlaced from "./Pages/OrderPlaced";
import ProfileEditData from "./Pages/Profile/ProfileEditData";
import ProfileOrders from "./Pages/Profile/ProfileOrders";
import ProfileAddresses from "./Pages/Profile/ProfileAddresses";
import ProfileCards from "./Pages/Profile/ProfileCards";
import ProfileChangePassword from "./Pages/Profile/ProfileChangePassword";
import ProfileHome from "./Pages/Profile/ProfileHome";
import Profile from "./Pages/Profile/Profile";
import AppRouter from "./Pages/AppRouter";

function App() {

    const { mainLoading, company, setCompany, versionFront } = useLayoutContext();
    const { cartConference, cartDisplay, showCartIsFinished, setShowCartIsFinished, cartFinished, showConfirmTable, setShowConfirmTable } = useCartContext();
    const { user, token, setToken, guestToken, setGuestToken } = useLoginContext();
    const { cashier } = useStoreContext();
    const { getOpenedCustomerCartDiffStored, removeOldCart, updatedFrontVersion } = useCartHook();
    const { showCart, setShowCart, showCartConference, setShowCartConference } = useCartContext();
    const { orderType, showOrderTypeChoice, setShowOrderTypeChoice, isStoreCounter } = useOrderTypeContext();
    const { showLoginStoreCounter, setShowLoginStoreCounter, showLoginBasic, setShowLoginBasic, closeableLogin } = useLoginContext();
    const { isMobile, setCompanyPages } = useLayoutContext();

    //* Verificando e removendo comanda finalizada depois de 2 horas ou comparando os caixas
    const checkCartFinished = () => {
        const dateStr = cartFinished?.order?.created_at?.date;
        if (typeof dateStr === 'string' && dateStr.trim()) {
            const orderCreatedAtTimestamp = convertDateToTimestamp(dateStr);
            if (isPastHours(orderCreatedAtTimestamp) || (cashier && cashier?.id !== cartFinished?.order?.cashier_id)) {
                removeOldCart();
            }
        }
    }

    useEffect(() => {
        const loadCompanyInfo = async () => {
            try {
                const companyService = new CompanyService(orderType);
                const companyInfo = await companyService.info();
                if (companyInfo) {
                    setCompany(companyInfo)
                    setCompanyPages(companyInfo.company_pages)
                    applyColorsToTailwind(companyInfo.styles)
                }
            } catch (error) {}
        }
        loadCompanyInfo();

        const applyColorsToTailwind = (colors: any) => {
            const root = document.documentElement;
            Object.keys(colors).forEach(key => {
                root.style.setProperty(`--color-${key}`, colors[key]);
            });
        }

        //* Verificando se a comanda do localStorage é diferente da aberta e substuindo
        if (token && cartDisplay) {
            getOpenedCustomerCartDiffStored(token);
        }

        checkCartFinished();

        //* Verificando se houve atualização no refreshToken
        if (token) {
            const storedToken = localStorage.getItem('token');
            if (storedToken !== token) {
                setToken(storedToken);
            }
        }

        //! TESTAR
        if (guestToken) {
            const storedGuestToken = localStorage.getItem('guest_token');
            if (storedGuestToken !== guestToken) {
                setGuestToken(storedGuestToken);
            }
        }

        //* Verificando versão do frontend
        if(process.env.REACT_APP_VERSION !== versionFront) {
            updatedFrontVersion();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        checkCartFinished();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cashier]);

    useEffect(() => {
        //* Alterando o favicon do projeto com base na imagem da Company
        if (company && company.square_image) {
            const link = document.querySelector("link[rel='icon']") as HTMLLinkElement || document.createElement('link');
            link.rel = 'icon';
            link.href = company.square_image;
            document.head.appendChild(link);
        }
    }, [company]);

    return (
        <>
            <Offline />
            <BrowserRouter>

                <Modal open={mainLoading} className="max-w-xs m-4" closeable={false} onClose={() => {}}>
                    <LoadingMain />
                </Modal>

                <Routes>
                    <Route path="/" element={<AppRouter />} />
                    <Route path="/lojas" element={<Stores />} />
                    <Route path="/perfil" element={<Profile />}>
                        <Route index element={<ProfileHome />} />
                        <Route path="dados-cadastrais" element={<ProfileEditData />} />
                        <Route path="meus-pedidos" element={<ProfileOrders />} />
                        <Route path="meus-enderecos" element={<ProfileAddresses />} />
                        <Route path="meus-cartoes" element={<ProfileCards />} />
                        <Route path="alterar-senha" element={<ProfileChangePassword />} />
                    </Route>
                    <Route path="/:order_type" element={<AppRouter />} />
                    <Route path="/:order_type/:slug" element={<AppRouter />}>
                        <Route index element={<Home />} />
                        <Route path="checkout" element={<Checkout />} />
                    </Route>
                    <Route path="/:order_type/:slug/mesa/:table_id" element={<AppRouter />}>
                        <Route index element={<Home />} />
                        <Route path="checkout" element={<Checkout />} />
                    </Route>

                    <Route path="/:order_type/:slug/order/:order_id/placed" element={<OrderPlaced />} />

                    {/* NotFound */}
                    <Route path="*" element={<AppRouter />} />
                </Routes>

                {/* DRAWER CART */}
                <Drawer open={showCart}
                    title={isStoreCounter 
                        ? user?.name 
                        : 'Seu carrinho'
                    }
                    subtitle={
                        <div className="flex gap-1">
                            { (isStoreCounter && cartDisplay)
                                ?
                                    <>
                                        <Badge type="custom" className="text-sm md:text-xs pl-1"><TbHash />{ formatCartId(cartDisplay.id) }</Badge>
                                        {cartDisplay.table && <Badge type="custom" outline className="text-sm md:text-xs gap-0.5"><MdTableRestaurant />{cartDisplay.table.name}</Badge>}
                                    </>
                                : ''
                            }
                        </div>
                    }
                    fromBottom={isMobile} onClose={() => setShowCart(false)}
                    >
                    <Cart onCloseCart={() => setShowCart(false)} />
                </Drawer>

                {/* DRAWER CART CONFERENCE */}
                {/* {!showConfirmTable && condição para remover conflitos na rolagem da listagem de mesas */ }
                    <Drawer
                        open={showCartConference} 
                        title={isStoreCounter
                            ? `${user?.first_name}, confira seu pedido`
                            : `${user ? `${user?.first_name}, confira seu carrinho` : 'Confira seu carrinho'}`
                        }
                        subtitle={cartDisplay && <div className="flex gap-1"><Badge type="custom" className="text-sm md:text-xs pl-1"><TbHash />{ formatCartId(cartDisplay.id) }</Badge> <Badge type="custom" outline className="text-sm md:text-xs gap-0.5"><MdTableRestaurant />{cartDisplay.table?.name}</Badge></div>}
                        fromBottom={isMobile}
                        onClose={() => setShowCartConference(false)}
                        >
                        <CartConference cart={cartConference} onCloseCart={() => setShowCartConference(false)} />
                    </Drawer>
                {/* } */}

                {/* MODAL CONFIRM TABLE */}
                <Drawer
                    open={showConfirmTable}
                    fromBottom={isMobile}
                    onClose={() => setShowConfirmTable(false)}
                    closeable={false}
                    >
                    <TableChoice onShowConfirmTable={(e: boolean) => setShowConfirmTable(e)} />
                </Drawer>

                {/* MODAL BASIC LOGIN */}
                <Modal open={showLoginBasic} className="max-w-sm m-4" onClose={() => setShowLoginBasic(false)} closeable={false}>
                    <LoginBasic onClose={() => setShowLoginBasic(false)} />
                </Modal>

            </BrowserRouter>

            {/* MODAL SERVICE CHOICE */}
            <Modal open={showOrderTypeChoice} className="max-w-2xl m-4" onClose={() => setShowOrderTypeChoice(false)}>
                <ServicesChoice onClose={() => setShowOrderTypeChoice(false)} />
            </Modal>

            {/* MODAL LOGIN STORE_COUNTER */}
            <Modal open={showLoginStoreCounter} className="max-w-sm m-4" onClose={() => setShowLoginStoreCounter(false)} closeable={closeableLogin}>
                <LoginStoreCounter onClose={() => setShowLoginStoreCounter(false)} closeable={closeableLogin} />
            </Modal>

            {/* CART FINISHED */}
            {cartFinished &&
                <Drawer open={showCartIsFinished}
                    title='Seu comprovante'
                    fromBottom={isMobile} onClose={() => setShowCartIsFinished(false)}
                    >
                    <ProofPayment
                        cart_id={cartFinished.order.cart.id}
                        payment_method={cartFinished.order.payment_method}
                        payment_methods={cartFinished.order.payment_methods}
                        order_id={cartFinished.order.id}
                        showButtonOpenNewCart={!cartDisplay && cashier}
                    />
                </Drawer>
            }

        </>
    );
}

export default App;